import React from "react";
import {
  withStyles,
  Grid,
} from "@material-ui/core";
import Profile from '../../../template/Header/Profile';
import InputSearchRetangular from "../../../components/Input/InputSearchRetangular";
import { ReactSelect } from "../../../components/Select/SelectSearch";
import { Button } from "../../../components/ui/Buttons";

const HeaderConfiguracoesButtonNovo = (props) => {
  const { 
    classes,
    handleClickNovo,
    title,
    status,
    showStatus,
    labelButton,
    hiddenButton,
    search,
    secondaryButton,
    idPrefix = "cfg-hcb"
  } = props;

  return(
    <header className={classes.headerRoot} >
      <div>
        <div className={classes.title}>{title}</div>
        <InputSearchRetangular
              id={`${idPrefix}-inp-pes`}
              placeholder={"Pesquisar"}
              onKeyPress={search?.onKeypress}
              className={classes.search}
              value={search?.value}
              onChange={(e) => search?.handleChange(e)}
              onClickButtonSearch={search?.onClickButtonSearch}
              handleClickClear={search?.handleClickClear}
            />
      </div>
        <div className={classes.wrapperFilters}>
          <Grid className={classes.contentHeader}>
                <div className={classes.filterStatus}>
                {showStatus && (
                  <>
                    <span className={classes.label}>Status:</span>
                    <ReactSelect
                      id={`${idPrefix}-sel-sta`}
                      placeholder="Selecione"
                      className={classes.select}
                      options={status.options}
                      value={status.value}
                      onChange={(item) => status.onChange(item)}
                    />
                  </>
                  )}
          </div>
            {hiddenButton ? null : (
              <div className={classes.buttonsContainer}>
                <Button
                  id={`${idPrefix}-btn-nov`}
                  bgColor="#219A97"
                  onClick={() => handleClickNovo()}
                >
                  {labelButton}
                </Button>
                {secondaryButton && (
                  <Button
                    id={`${idPrefix}-btn-sec`}
                    color="#fff"
                    bgColor={secondaryButton.color || "#f44336"}
                    onClick={secondaryButton.onClick}
                    disabled={secondaryButton.disabled}
                  >
                    {secondaryButton.label}
                  </Button>
                )}
              </div>
            )}
          </Grid>
          <Profile />
      </div>
    </header>
  )
};

const style = {
  headerRoot: {
    display: 'flex',
    flexDirection: 'row',
    background: '#fff',
    position: 'relative',
    padding: '8px 16px',
    gap:'5px'
  },
  wrapperFilters: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    width: '100%',
  },
  search: {
    height: '32px',
    maxWidth: '500px',
    flex: 1,
    '& > div': {
      border: 'none !important',
    },
  },
  contentHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems:  'center',
    gap: '8px',
    flex: 1,
    alignSelf:'center',
  },
  title: {
    fontWeight: 700,
    fontSize: '18px',
    textWrap:"nowrap",
  },
  info: {
    color: '#333333',
    fontSize: '14px',
  },
  filterStatus: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    marginTop:'6px',
  },
  select: {
    width: 'auto',
    maxWidth: '200px',
  },
  label:{
    color:'#505050',
    fontSize:'12px !important',

  },
  buttonsContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
}

export default withStyles(style)(HeaderConfiguracoesButtonNovo);
